import { render, staticRenderFns } from "./movemodal.vue.html?vue&type=template&id=58b42091"
import script from "./movemodal.controller.ts?vue&type=script&lang=js&external"
export * from "./movemodal.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports